export const OurTotalsold =[
   {
      id: 1,
      title:"Ossim keter",
      year:"2023",
      date:"16 August",
      product:"Clothes",
      status:"Success",
      editbutton:"Edit",
      country:"flag-icon flag-icon-gb",
      price:"$1,58,652",
      img:"01.png"
   },
   {
      id: 2,
      title:"Venter loren",
      year:"2021",
      date:"21 September",
      product:"Branded Shoes",
      status:"Success",
      editbutton:"Edit",
      country:"flag-icon flag-icon-us",
      price:"$95,025",
      img:"02.png"
   },
   {
      id: 3,
      title:"Fran Loain",
      year:"2023",
      date:"06 March",
      product:"Electronics",
      status:"Success",
      editbutton:"Edit",
      country:"flag-icon flag-icon-za",
      price:"$90,155",
      img:"03.png"
   },
   {
      id: 4,
      title:"Loften Horen",
      year:"2021",
      date:"12 February",
      product:"Watch",
      status:"Success",
      editbutton:"Edit",
      country:"flag-icon flag-icon-at",
      price:"$80,658",
      img:"04.png"
   },
   {
      id: 5,
      title:"Loie fenter",
      year:"2023",
      date:"30 january",
      product:"Jewellery",
      status:"Success",
      editbutton:"Edit",
      country:"flag-icon flag-icon-br",
      price:"$50,652",
      img:"05.png"
   },
]